import { Model, attr } from '@elatonsev/js-models';

export default class NearestTimeModel extends Model {
  date = attr('date');
  time = attr('json', {defaultValue: []});
}